import { Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { isDevMode } from '@angular/core'
import { ConfigService } from './config.service'
import { shareReplay, Subject } from 'rxjs'
import { ApplicationEvent, ToastMessage } from '../types'
import { ClipboardService, IClipboardResponse } from 'ngx-clipboard'
import { TranslocoService } from '@jsverse/transloco'

@Injectable({
   providedIn: 'root'
})
export class MessagehandlerService {

   private toastSource$: Subject<ToastMessage> = new Subject<ToastMessage>()

   private appEventSource$: Subject<ApplicationEvent> = new Subject<ApplicationEvent>()

   public onToast$ = this.toastSource$.asObservable().pipe(shareReplay(1))

   public appEvents$ = this.appEventSource$.asObservable().pipe(shareReplay(1))

   constructor(private toastr: ToastrService, private config: ConfigService, private clipboard: ClipboardService, private translocoService: TranslocoService) {
      // configure all copies to show a success msg
      this.clipboard.copyResponse$.subscribe((res: IClipboardResponse) => {
         if (res.isSuccess) {
            this.toast({ type: 'info', title: this.translocoService.translate('action.copytitle'), message: res.successMessage ?? 'Success', options: {} })
         }
      })
   }

   toast(message: ToastMessage) {
      if (this.config.currentConfig?.showToast) {
         this.toastr[message.type](message.message, message.title, { ...message.options})
      }
      else {
         this.toastSource$.next(message)
      }
   }

   log(message: string, args = {}, type: 'info'|'debug'|'error' = 'info') {
      if (isDevMode()) {
         console[type](message, args)
      }
      else {
         // log something else?
      }
   }

   emitAppEvent(e: ApplicationEvent) {
      this.appEventSource$.next(e)
   }
}
